import { type User, createClient } from "@supabase/supabase-js";
import { handleError } from "./utils/handleError";
import { Database } from "./types/supabase";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
const hasSupabaseSessionInUrl = new URLSearchParams(
  window.location.hash.slice(1)
).has("access_token");

export const supabase = createClient<Database>(supabaseUrl!, supabaseAnonKey!, {
  auth: {
    storage: localStorage,
    persistSession: true,
    detectSessionInUrl: hasSupabaseSessionInUrl,
  },
});

let cachedUser: User | null = null;
export async function getUser() {
  if (cachedUser) {
    return cachedUser;
  }

  const {
    data: { user },
    error,
  } = await supabase.auth.getUser();

  if (error) {
    handleError(error);
    return;
  }

  cachedUser = user;
  return user;
}
